import React, { useState, useContext } from 'react';
import EmpresaContext from "../../../contexts/Empresa";
import api from "../../../services/api";
import {
    Button,
    Modal,
    Spinner,
} from "reactstrap";

export default ({ oportunidade, onEncerrado, notify }) => {

    const { empresaSelecionada } = useContext(EmpresaContext);
    const [showModal, setShowModal] = useState(false);
    const [saving, setSaving] = useState(false);

    function isNew() {
        return !(oportunidade && oportunidade.id);
    }

    async function handlerConverter() {
        setSaving(true);
        try {
            await api.put(
                `/marketing/oportunidades/${oportunidade.id}/converter`,
                {
                    user_id: empresaSelecionada?.id,
                }
            );
            if (notify) notify('success', 'Oportunidade convertida');
            setShowModal(false);
            if (onEncerrado) onEncerrado();
        } catch (error) {
            console.log(error);
            if (notify) notify('danger', 'Não foi possível converter a oportunidade');
        }
        setSaving(false);
    }

    return (
        <>
            {!isNew() && (
                <Button
                    color="success"
                    type="button"
                    onClick={() => setShowModal(true)}
                >
                    <i className="fas fa-dollar-sign mr-2" />
                    Converter
                </Button>
            )}
            <Modal
                className="modal-dialog-centered modal-success"
                size="md"
                isOpen={showModal}
                toggle={() => setShowModal(false)}
            >
                <div className="modal-header">
                    <h6 className="modal-title" id="modal-title-converter">
                        Converter oportunidade
                    </h6>
                </div>
                <div className="modal-body">
                    <div className="py-3 text-center">
                        <i className="fas fa-dollar-sign ni-3x" style={{ fontSize: '2rem' }} />
                        <h4 className="heading mt-4"></h4>
                        <p>
                            Você está prestes a converter esta oportunidade. Deseja prosseguir?
                        </p>
                    </div>
                </div>
                <div className="modal-footer">
                    <Button
                        className="text-white ml-auto"
                        color="link"
                        data-dismiss="modal"
                        type="button"
                        onClick={() => setShowModal(false)}
                        disabled={saving}
                    >
                        Fechar
                    </Button>
                    <Button
                        onClick={() => handlerConverter()}
                        className="btn-white"
                        color="default"
                        type="button"
                        disabled={saving}
                    >
                        {saving && <Spinner size="sm" className="mr-2" />}
                        Converter
                    </Button>
                </div>
            </Modal>
        </>
    );
};
